import { useState, useContext } from 'react';
import { Button } from '@monash/portal-react';
import c from './user-card.module.scss';
import { APIContext } from '@monash/portal-frontend-common';

const UserCard = ({ data, onEnd, onSelect, active = false }) => {
  const { endImpersonation, startImpersonation } = useContext(APIContext);
  const relevantId = data.isMockUser ? data.uid : data.studentId;

  const primaryDisplayText = data.isMockUser
    ? data.display?.admin?.cardLabelPrimary
    : `${data.name} ${data.studentId}`;
  const secondaryDisplayText =
    data.isMockUser && data.display?.admin?.cardLabelSecondary;

  const [isActive, setIsActive] = useState(active);
  const [loading, setLoading] = useState(false);
  const action = () => {
    setLoading(true);
    if (isActive) {
      endImpersonation().then(() => {
        setIsActive(false);
        setLoading(false);
        onEnd && onEnd();
      });
    } else {
      startImpersonation(relevantId).then((r) => {
        setIsActive(true);
        setLoading(false);
        onSelect && onSelect(r);
      });
    }
  };

  return (
    <div className={c.userCard}>
      <div className={c.displayTextContainer}>
        <span>
          <strong>{primaryDisplayText}</strong>
        </span>
        {secondaryDisplayText && <span>{secondaryDisplayText}</span>}
      </div>
      <div>
        <Button
          size="small"
          onClick={action}
          loading={loading}
          variant={isActive ? 'delete' : 'text'}
        >
          <span className={isActive ? c.end : null}>
            {isActive ? 'End impersonation' : 'Start impersonation'}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default UserCard;
